export const motivationalVideosState = {
  activeTab: 0,
  tabs: [
    {
      name: "Motivational",
    },
    { name: "Meditation" },
    {
      name: "Training Videos",
    },
    {
      name: "Training Documents",
    },
  ],
  teamId: 0,
  videos: [],
  videosMeta: {},
};

export const motivationalVideosReducer = (state, action) => {
  switch (action.type) {
    case "teamIdUpdated":
      return {
        ...state,
        teamId: action.value,
      };
    case "setActiveTab":
      return {
        ...state,
        videos: [],
        activeTab: action.value,
      };
    case "setVideos":
      return {
        ...state,
        videos: removeDuplicateDueTocall(
          action.value.hardReload ||
            Number(action.value.teamId) !== Number(state.teamId)
            ? [...action.value.videos]
            : [...state.videos, ...action.value.videos]
        ),
        videosMeta: action.value.videosMeta,
      };
    case "clearVideoState":
      return {
        activeTab: 0,
        tabs: [
          {
            name: "Motivational",
          },
          { name: "Meditation" },
          {
            name: "Training Videos",
          },
          {
            name: "Training Documents",
          },
        ],
        teamId: 0,
        videos: [],
        videosMeta: {},
      };
    default:
      return state;
  }
};

const removeDuplicateDueTocall = (data) => {
  var resArr = [];

  data.filter((item) => {
    var i = resArr.findIndex((x) => x.id === item.id);
    if (i <= -1) {
      resArr.push(item);
    }
    return null;
  });
  return resArr.sort((a, b) => b.is_forwarded - a.is_forwarded);
};
